module.exports = __webpack_public_path__ + "static/media/plus_green_light.cd64ea85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/plus_green_light.svg
// module id = 362
// module chunks = 0